// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: "authce9d77b308c149d5992a80073637e4d5",
	registerKey: "6LfM76sUAAAAAApKii_UzsTn__Ad2JOU-71LW_66",
	Use_Analytics: false,
	//dev setup
	// BASE_URL_PROFILE: "http://192.168.128.154:84/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://192.168.128.154:84/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://192.168.128.154:84/hec-das-rest/rest/",
	// BASE_URL_DES: "http://192.168.128.154:84/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://192.168.128.224:84/hec-rpt-rest/rest/",

	//test setup
	// BASE_URL_PROFILE: "http://192.168.128.154:85/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://192.168.128.154:85/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://192.168.128.154:85/hec-das-rest/rest/",
	// BASE_URL_DES: "http://192.168.128.154:85/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://192.168.128.154:85/hec-rpt-rest/rest/",
	// BASE_URL_HRD: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',
	// BASE_URL_COMMON_RGA: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',

	//des setup
	// BASE_URL_PROFILE: "http://192.168.128.154:84/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://192.168.128.154:84/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://192.168.128.154:84/hec-das-rest/rest/",
	// BASE_URL_DES: "http://192.168.128.154:84/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://192.168.128.154:84/hec-rpt-rest/rest/",

	//mehar setup
	// BASE_URL_PROFILE: "http://192.168.146.45:9080/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://192.168.146.45:9080/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://192.168.146.45:9080/hec-das-rest/rest/",
	// BASE_URL_DES: "http://192.168.146.45:9080/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://192.168.146.45:9080/hec-rpt-rest/rest/",

	//qa setup

	// BASE_URL_PROFILE: "http://hec-app-qa:85/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://hec-app-qa:85/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://hec-app-qa:85/hec-das-rest/rest",

	//for ECourses UAT
	// BASE_URL_PROFILE: "http://10.87.204.248:81/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://10.87.204.248:81/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://10.87.204.248:81/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://10.87.204.248:81/hec-rpt-rest/rest/",
	// BASE_URL_DES: "http://10.87.204.248:81/hec-das-rest/rest/",
	// BASE_URL_HRD: "http://10.87.204.248:81/hec-hrd-rest/rest/",
	// BASE_URL_COMMON_RGA: "https://research.hec.gov.pk//hec-rnd-rest/rest/",
	// BASE_URL_COURSERA: "http://10.87.204.240:81/startup-1.0/",
	// BASE_URL_PCD: "http://10.87.204.248/startup-1.0/",
	// JWT: "jwt",

	//for DES UAT
	// BASE_URL_PROFILE: "http://10.87.204.248/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://10.87.204.248/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://10.87.204.248/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://10.87.204.248/hec-rpt-rest/rest/",
	// BASE_URL_DES: "http://10.87.204.248/hec-das-rest/rest/",
	// BASE_URL_HRD: "http://10.87.204.248/hec-hrd-rest/rest/",
	// BASE_URL_COMMON_RGA: "https://research.hec.gov.pk//hec-rnd-rest/rest/",
	// BASE_URL_COURSERA: "http://10.87.204.240/startup-1.0/",
	// BASE_URL_PCD: "http://10.87.204.248:82/startup-1.0/",
	// JWT: "jwt",

	// BASE_URL_PCD: "http://10.87.204.248:82/startup-1.0/",

	// BASE_URL_COMMON: "http://10.72.1.73//hec-common-rest/rest/",

	// BASE_URL_PROFILE: "http://10.72.1.73//hec-profile-rest/rest/",

	// BASE_URL_HRD: "http://10.72.1.73/hec-rnd-rest/rest/",

	// BASE_URL_RPT: "http://10.72.1.73/hec-rpt-rest/rest/",

	// BASE_URL_HRD1: "http://10.72.1.73/hec-hrd-rest/rest/",

	// BASE_URL_SPRING_RND: "http://10.72.1.73/hec-rnd-rest/rest/rnd/",

	// BASE_URL_POSTAWARD: "http://10.87.204.242:81/startup-1.0/postAward/",

	// BASE_URL_POSTAWARD_REVIEW: "http://10.72.1.73/startup-1.0/review/",

	// BASE_URL_SPRING_CMN: "http://10.87.204.242:81/startup-1.0/cmn/",

	// BASE_SPRING_AUTH: "http://10.72.1.73/startup-1.0/",

	// BASE_URL_ASIP_ADMIN: "http://10.87.204.252:8082/startup-asip-1.0/admin/",

	// BASE_SPRING_AUTH_ASIP: "http://10.87.204.252:8082/startup-asip-1.0/",

	// BASE_SPRING_RGA: "http://10.87.204.252:8081/startup-1.0/rgaResource/",

	//for DAS UAT
	// 	BASE_URL_PROFILE: "http://10.72.0.66/hec-profile-rest/rest/",
	// 	BASE_URL_COMMON: "http://10.72.0.66/hec-common-rest/rest/",
	// 	BASE_URL_DAS: "http://10.72.0.66/hec-das-rest/rest/",
	// 	BASE_URL_RPT: "http://10.72.0.66/hec-rpt-rest/rest/",
	// 	BASE_URL_DES: "http://10.72.0.66/hec-das-rest/rest/",
	// 	BASE_URL_HRD: 'http://10.72.0.66/hec-hrd-rest/rest/',
	// 	BASE_URL_COMMON_RGA: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',
	// //	BASE_URL_PCD: "http://10.87.204.248/startup-1.0/",
	// //	JWT: "jwt",
	//     BASE_URL_COURSERA: "http://10.87.204.240/startup-1.0/",
	// 	// BASE_URL_PCD: "http://10.87.204.248:82/startup-1.0/",
	// 	BASE_URL_PCD: "https://eservices.hec.gov.pk/startup-1.0//",

	// 	JWT: "jwt",


	// // PROD
	BASE_URL_PROFILE: "https://eservices.hec.gov.pk/hec-profile-rest/rest/",
	BASE_URL_COMMON: "https://eservices.hec.gov.pk/hec-common-rest/rest/",
	BASE_URL_DAS: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	BASE_URL_RPT: "https://eservices.hec.gov.pk/hec-rpt-rest/rest/",
	BASE_URL_DES: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	BASE_URL_DESF: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	BASE_URL_HRD: 'https://eservices.hec.gov.pk/hec-hrd-rest/rest/',
	BASE_URL_COURSERA: "https://eservices.hec.gov.pk/startup-1.0/",
	BASE_URL_PCD: "https://eservices.hec.gov.pk/startup-1.0/",
	// BASE_URL_PCD: "http://10.110.0.149:8099/startup-1.0/",
	BASE_URL_COMMON_RGA: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',
	JWT: "jwt",

	// UAT
	// BASE_URL_PROFILE: "http://10.110.0.137:81/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://10.110.0.137:81/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://10.110.0.137:81/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://10.110.0.137:81/hec-rpt-rest/rest/",
	// BASE_URL_DES: "http://10.110.0.137:81/hec-das-rest/rest/",
	// BASE_URL_DESF: "http://10.110.0.137:81/hec-das-rest/rest/",
	// BASE_URL_HRD: 'http://10.110.0.137:81/hec-hrd-rest/rest/',
	// BASE_URL_COURSERA: "http://10.110.0.137:8088/startup-1.0/",
	// BASE_URL_PCD: "http://10.110.0.137:8088/startup-1.0/",
	// BASE_URL_COMMON_RGA: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',
	// JWT: "jwt",

	// PROD --- these are the production endpoints
	// BASE_URL_PROFILE: "https://eservices.hec.gov.pk/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "https://eservices.hec.gov.pk/hec-common-rest/rest/",
	// BASE_URL_DAS: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	// BASE_URL_RPT: "https://eservices.hec.gov.pk/hec-rpt-rest/rest/",
	// BASE_URL_DES: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	// BASE_URL_DESF: "https://eservices.hec.gov.pk/hec-das-rest/rest/",
	// BASE_URL_HRD: "https://eservices.hec.gov.pk/hec-hrd-rest/rest/",
	// //BASE_URL_COURSERA: "http://10.110.6.10:8081/startup-1.0/",
	// BASE_URL_COURSERA: "https://eservices.hec.gov.pk/startup-1.0/",
	// BASE_URL_PCD: "https://eservices.hec.gov.pk/startup-1.0/",
	// BASE_URL_COMMON_RGA: "https://research.hec.gov.pk//hec-rnd-rest/rest/",
	// JWT: "jwt",

	//prod setup
	// BASE_URL_PROFILE: "http://10.110.0.138:9080/hec-profile-rest/rest/",
	// BASE_URL_COMMON: "http://10.110.0.138:9080/hec-common-rest/rest/",
	// BASE_URL_DAS: "http://10.110.0.138:9080/hec-das-rest/rest/",
	// BASE_URL_DES: "http://10.110.0.138:9080/hec-das-rest/rest/",
	// BASE_URL_RPT: "http://10.110.0.138:9080/hec-rpt-rest/rest/",
	// BASE_URL_HRD: 'http://10.110.0.138:9080/hec-rnd-rest/rest/',
	// BASE_URL_COMMON_RGA: 'https://research.hec.gov.pk//hec-rnd-rest/rest/',

	version: 1.1,
	firebase: {
		apiKey: "AIzaSyDlfzULpcc-YpSuZp4sDct7y7lJGpe0j8Y",
		authDomain: "hec-project-9307e.firebaseapp.com",
		databaseURL: "https://hec-project-9307e.firebaseio.com",
		projectId: "hec-project-9307e",
		storageBucket: "hec-project-9307e.appspot.com",
		messagingSenderId: "983835680141",
		appId: "1:983835680141:web:5d2e4ddbd335b1395871c4",
		measurementId: "G-F3YCKCN2TT",
	},
};
